import { useState, useEffect } from 'react';
import { getCustomerShippingData } from '../services/customerShippingDataService';


export interface CustomerShippingData {
    // Order identification
    order_id: string;
    name: string;
    
    // Customer information
    customer_name: string;
    customer_first_name: string;
    customer_last_name: string;
    email: string;
    phone: string;
    customer_amount_spent: number;
    customer_no_of_orders: number;
    
    // Order timestamps and status
    created_at: string; // datetime as ISO string
    updated_at: string; // datetime as ISO string
    closed_at: string | null; // datetime as ISO string or null
    closed: boolean;
    cancelled_at: string | null; // datetime as ISO string or null
    cancel_reason: string | null;
    
    // Order metadata
    tags: string | null; // nvarchar(max)
    note: string | null; // nvarchar(max)
    
    // Financial information
    currency_code: string;
    financial_status: string;
    return_status: string;
    fulfillment_status: string;
    refundable: boolean;
    unpaid: boolean;
    fully_paid: boolean;
    
    // Pricing
    total_quantity: number;
    total_price: number; // decimal(18,2)
    subtotal_price: number; // decimal(18,2)
    total_discount: number; // decimal(18,2)
    total_shipping_price: number; // decimal(18,2)
    total_tax: number; // decimal(18,2)
    discount_codes: string | null;
    
    // Payment and location
    payment_gateways: string;
    billing_address_formatted: string;
    shipping_address_formatted: string;
    retail_location_name: string;
    
    // Staff information
    staff_exists: boolean;
    staff_name: string | null;
  }



interface UseCustomerShippingDataReturn {
  data: CustomerShippingData | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}


export const useCustomerShippingData = (orderId: string | null): UseCustomerShippingDataReturn => {
  const [data, setData] = useState<CustomerShippingData | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomerShippingData = async () => {
    if (!orderId) return;

    setLoading(true);
    setError(null);

    try {
      const data = await getCustomerShippingData(orderId);
      setData(data);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch customer shipping data';
      setError(errorMessage);
      console.error('Error fetching customer shipping data:', err);
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    fetchCustomerShippingData();
  };

  useEffect(() => {
    fetchCustomerShippingData();
  }, [orderId]);

  return {
    data,
    loading,
    error,
    refetch
  };
};